export default __webpack_public_path__ + "static/media/MaisonNeue-MediumItalic.d66baf99.woff2";